import styled from "styled-components";

export const Main = styled.div`
    box-sizing: border-box;
    width: 100%;
    transform: translate3d(0, 0, 0);
    margin-top: 90px;
    transition: all 300ms ease-in;
`;
